"use client";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

const MovingBox = () => {
  const controls = useAnimation();
  const ImageControls = useAnimation();
  const [isPaused, setIsPaused] = useState(false);
  const [isImagePaused, setIsImagePaused] = useState(false);

  const ImageSrc = [
    {
      id: 1,
      imgsrc: "/assets/character--ram.png",
      imgtitle: "ram",
      heading: "Upholder of Dharma",
      subheading: "Ideal King & Son",
    },
    {
      id: 2,
      imgsrc: "/assets/character--lakshman.png",
      imgtitle: "lakshman",
      heading: "Protective Brother",
      subheading: "Faithful Companion",
    },
    {
      id: 3,
      imgsrc: "/assets/character--sugriv.png",
      imgtitle: "sugriv",
      heading: "Loyal Friend",
      subheading: "Vanara King",
    },

    {
      id: 4,
      imgsrc: "/assets/character--shatrughan.png",
      imgtitle: "shatrughan",
      heading: "Supportive Brother",
      subheading: "Quiet Strength",
    },

    {
      id: 5,
      imgsrc: "/assets/character--hanuman.png",
      imgtitle: "hanuman",
      heading: "Devoted Servant",
      subheading: "Fearless Warrior",
    },
    {
      id: 6,
      imgsrc: "/assets/character--ravan.png",
      imgtitle: "ravan",
      heading: "Mighty King of Lanka",
      subheading: "Trapped by Ego",
    },
    {
      id: 7,
      imgsrc: "/assets/character--vibhishan.png",
      imgtitle: "vibhishan",
      heading: "Voice of Wisdom",
      subheading: "Ally of Dharma",
    },
    {
      id: 8,
      imgsrc: "/assets/character--bharat.png",
      imgtitle: "bharat",
      heading: "Selfless Ruler",
      subheading: "Devoted to Rama",
    },

    {
      id: 9,
      imgsrc: "/assets/character--indrajit.png",
      imgtitle: "indrajit",
      heading: "Skilled Warrior",
      subheading: "Devoted Son of Ravana",
    },
    {
      id: 10,
      imgsrc: "/assets/character--sita.png",
      imgtitle: "sita",
      heading: "Symbol of Purity",
      subheading: "Devoted Wife",
    },
    {
      id: 11,
      imgsrc: "/assets/character--garud.png",
      imgtitle: "garuda",
      heading: "Divine Protector",
      subheading: "Vehicle of Vishnu",
    },
  ];

  const names = [
    "Rama",
    "Sita",
    "Lakshmana",
    "Bharata",
    "Shatrughna",
    "Hanuman",
    "Ravana",
    "Vibhishana",
    "Sugriva",
    "Vali",
    "Jatayu",
    "Indrajit",
  ];
  useEffect(() => {
    controls.start({
      x: ["0%", "-100%"],
      transition: {
        duration: 20,
        repeat: Infinity,
        ease: "linear",
      },
    });

    ImageControls.start({
      x: ["0%", "-50%"],
      transition: {
        duration: 20,
        repeat: Infinity,
        ease: "linear",
      },
    });
  }, [controls, ImageControls]);
  return (
    <div className="flex flex-col gap-9 bg-[#f7f3e9]">
      {/* Names marquee */}
      <div
        className="bg-gradient-to-r from-[#f7f3e9] via-[#d4af37] to-[#f7f3e9] py-6 px-8 rounded-xl shadow-lg overflow-hidden
        [-webkit-mask-image:linear-gradient(to right, transparent, black 15%, black 85%, transparent)]
        [-webkit-mask-repeat:no-repeat] 
        [-webkit-mask-size:100%]"
      >
        <motion.ul
          animate={controls}
          initial={{ x: "0%" }}
          onMouseEnter={() => {
            controls.stop();
            setIsPaused(true);
          }}
          onMouseLeave={() => {
            controls.start({
              x: ["0%", "-100%"],
              transition: { duration: 20, repeat: Infinity, ease: "linear" },
            });
            setIsPaused(false);
          }}
          style={{ willChange: "transform" }}
          className="font-[Inter] text-xl flex flex-row gap-x-[60px]"
        >
          {names.map((n, i) => (
            <li
              key={i}
              className="hover:text-[#d4af37] cursor-pointer select-none transition-colors duration-200"
            >
              {n}
            </li>
          ))}
          {/* Duplicate set */}
          {names.map((n, i) => (
            <li
              key={`dup-${i}`}
              className="hover:text-[#d4af37] cursor-pointer select-none transition-colors duration-200"
            >
              {n}
            </li>
          ))}
        </motion.ul>
      </div>

      {/* Images marquee */}
      <div
        className="relative overflow-hidden p-6 bg-[#f7f3e9]
        [-webkit-mask-image:linear-gradient(to right, transparent, black 15%, black 85%, transparent)]
        [-webkit-mask-repeat:no-repeat] [-webkit-mask-size:100%]"
      >
        <motion.div
          animate={ImageControls}
          initial={{ x: "0%" }}
          onMouseEnter={() => {
            ImageControls.stop();
            setIsImagePaused(true);
          }}
          onMouseLeave={() => {
            ImageControls.start({
              x: ["0%", "-50%"],
              transition: { duration: 10, repeat: Infinity, ease: "linear" },
            });
            setIsImagePaused(false);
          }}
          style={{ willChange: "transform" }}
          className="flex flex-row gap-6"
        >
          {ImageSrc.map(({ id, imgsrc, imgtitle, heading, subheading }) => (
            <figure
              key={id}
              className="relative group rounded-xl shadow-lg w-[192px] h-[256px] flex-shrink-0"
            >
              <Image
                src={imgsrc}
                alt={imgtitle}
                width={192}
                height={256}
                loading="lazy"
                className="w-full h-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
              />
              <figcaption className="absolute inset-0 backdrop-blur-md bg-opacity-40 flex flex-col items-center justify-center text-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <h1 className="text-2xl font-extrabold text-white drop-shadow-lg mb-2">
                  {imgtitle.charAt(0).toUpperCase() + imgtitle.slice(1)}
                </h1>
                <h2 className="text-xl font-bold text-gray-100 mb-1">
                  {heading}
                </h2>
                <p className="text-base font-medium text-gray-200">
                  {subheading}
                </p>
              </figcaption>
            </figure>
          ))}
          {/* Duplicate set*/}
          {ImageSrc.map(({ id, imgsrc, imgtitle, heading, subheading }) => (
            <figure
              key={`dup-${id}`}
              className="relative group rounded-xl shadow-lg w-[192px] h-[256px] flex-shrink-0"
            >
              <Image
                src={imgsrc}
                alt={imgtitle}
                width={192}
                height={256}
                loading="lazy"
                className="w-full h-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
              />
              <figcaption className="absolute inset-0 backdrop-blur-md bg-opacity-40 flex flex-col items-center justify-center text-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <h1 className="text-2xl font-extrabold text-white drop-shadow-lg mb-2">
                  {imgtitle.charAt(0).toUpperCase() + imgtitle.slice(1)}
                </h1>
                <h2 className="text-xl font-bold text-gray-100 mb-1">
                  {heading}
                </h2>
                <p className="text-base font-medium text-gray-200">
                  {subheading}
                </p>
              </figcaption>
            </figure>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default MovingBox;
